/*
 * Hora de llegada en el dashboard: distribución por tramos (antes de 07:30, 07:30 a 08:00, 08:00 a 08:10,
 * después de 08:10; spec 4.2 c) con la cantidad escrita debajo, y mapa de calor de entradas por bloque de
 * 15 minutos x día de la semana (spec 4.7). Datos preparados por utils/dashboard.js.
 * El mapa de calor se recorta a las horas con entradas (trimHeatmap: una entrada de madrugada no estira el
 * eje) y, si aun así es ancho (más de ~5 h), se desplaza en horizontal dentro de su panel (foco con teclado)
 * para no romper el diseño en pantallas de 375 px. Si se omite un hueco de 3 h o más se avisa bajo el mapa, y una
 * leyenda propia (texto + color) explica la escala. Los porcentajes null del servidor no se muestran.
 */
import React from "react";
import {BarChart, HeatmapChart} from "../../components/charts";
import {
    distributionChart, formatKpiValue, heatmapLabel, heatmapMax, heatmapRanges, heatmapSeries, omittedHoursNotice, trimHeatmap,
} from "../../utils/dashboard";

const BLOCK_WIDTH = 18;
const HEAT_LEFT_MARGIN = 90;

const ArrivalPanels = ({datos}) => {
    const distribution = distributionChart(datos.distribucion_llegada);
    const hasArrivals = distribution.values.some((value) => value > 0);
    const heatmap = trimHeatmap(datos.mapa_calor);
    const ranges = heatmapRanges(heatmapMax(heatmap));
    const notice = omittedHoursNotice(heatmap.omitidas);
    const wide = heatmap.bloques.length * BLOCK_WIDTH + HEAT_LEFT_MARGIN;
    return (
        <div className="mc-grid mc-grid--2">
            <div className="mc-panel">
                <h3 className="mc-panel__title">¿A qué hora llegan?</h3>
                <p className="mc-panel__hint">Jornadas de lunes a viernes, por tramo de llegada.</p>
                {hasArrivals ? (
                    <>
                        <BarChart categories={distribution.categories} values={distribution.values} horizontal
                                  colors={distribution.colors} height={200} label="Llegadas por tramo"
                                  summary={`Llegadas por tramo. ${distribution.label}`}/>
                        <ul className="mc-legend">
                            {datos.distribucion_llegada.map((row) => (
                                <li key={row.tramo}>
                                    <span className={`mc-legend__dot mc-legend__dot--${row.tramo}`} aria-hidden="true"/>
                                    {row.etiqueta}: <strong className="mc-num">{row.cantidad}</strong>
                                    {row.porcentaje !== null && row.porcentaje !== undefined
                                        ? ` (${formatKpiValue('%', row.porcentaje)})` : ''}
                                </li>
                            ))}
                        </ul>
                    </>
                ) : <p className="mc-inline-empty">Sin llegadas de lunes a viernes en este rango.</p>}
            </div>
            <div className="mc-panel">
                <h3 className="mc-panel__title">Mapa de calor de llegadas</h3>
                <p className="mc-panel__hint">Entradas por bloque de 15 minutos y día de la semana (incluye sábado y domingo).</p>
                {heatmap.series.length ? (
                    <div className="mc-scroll-x" tabIndex={0} role="region" aria-label="Mapa de calor de llegadas (se desplaza en horizontal)">
                        <div style={{minWidth: wide}}>
                            <HeatmapChart series={heatmapSeries(heatmap)} ranges={ranges}
                                          label="Mapa de calor de llegadas" summary={`Mapa de calor de llegadas. ${heatmapLabel(heatmap)}`}/>
                        </div>
                    </div>
                ) : null}
                {heatmap.series.length ? (
                    <>
                        {notice ? <p className="mc-chart-note">{notice}</p> : null}
                        <ul className="mc-legend" aria-label="Escala de entradas por bloque">
                            {ranges.map((range) => (
                                <li key={range.name}>
                                    <span className="mc-legend__swatch" style={{background: range.color}} aria-hidden="true"/>
                                    {range.name}
                                </li>
                            ))}
                        </ul>
                    </>
                ) : <p className="mc-inline-empty">Sin entradas en este rango.</p>}
            </div>
        </div>
    );
};

export default ArrivalPanels;
